import OpenQueryQueries from "./OpenQueryQueries-container";

export default OpenQueryQueries;